import React from 'react';
import { Button, Typography } from '@saviynt/design-system';
import PropTypes from 'prop-types';

import { useInvertedLocalize } from '../../../../../../utils/localization';
import { invertedMessages } from '../../../messages';
import { textWhenNoDataErrorForSidePanel } from '../utils';

function CertsSidePanelBodyError({
  tab,
  retriggerApisForError,
  handleCloseSidePanel,
}) {
  const l = useInvertedLocalize(invertedMessages);

  return (
    <div className='CertsSidePanelBody-tabContent--isError'>
      <Typography kind='h2'>{l("Couldn't Load")}</Typography>
      <Typography
        kind='body2'
        className='CertsSidePanelBody-tabContentDescription--isError'>
        {l(textWhenNoDataErrorForSidePanel(tab))}
      </Typography>
      <Button
        type='button'
        kind='outlined'
        isEnabled
        onClick={retriggerApisForError}
        className='CertsSidePanelBody-tabContentRefreshBtn--isError'
        size='small'>
        {l('Refresh')}
      </Button>
      <Button
        type='button'
        kind='ghost'
        size='small'
        onClick={handleCloseSidePanel}>
        {l('Close')}
      </Button>
    </div>
  );
}

CertsSidePanelBodyError.propTypes = {
  tab: PropTypes.string,
  retriggerApisForError: PropTypes.func.isRequired,
  handleCloseSidePanel: PropTypes.func.isRequired,
};

CertsSidePanelBodyError.defaultProps = { tab: '' };

export default CertsSidePanelBodyError;
